// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_ma-5";
export var filledCircle = "_ma-4";
export var historyEntry = "_ma-3";
export var messageSideLeft = "_ma-1";
export var messageSideRight = "_ma-2";
export var orderTrackingCarouselWrapper = "_ma-6";
export var orderTrackingInfoContainer = "_ma-0";